import React from 'react'
import '../css/footer.css'; 
export default function Footer() {
    return (
        <>
            {/* Footer Section  */}
            <footer class="footer">
                <p>© 2024 Ashar Naveed.</p>

            </footer>

        </>
    )
}
